import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthModal from "../components/AuthModal";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";

const ROLE_LABEL = { tenants: "Tenant", landlords: "Landlord", buyers: "Buyer", vendors: "Vendor" };

// Dedicated /login route so the sign-in form is reachable by direct URL.
const LoginPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [params] = useSearchParams();
  const roleLabel = ROLE_LABEL[params.get("role")];
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (user) {
      const dest = user.role === "admin" || user.role === "agent" ? "/admin"
        : ["vendor", "landlord", "tenant", "buyer"].includes(user.role) ? "/portal" : "/";
      navigate(dest, { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-[#faf7f2] px-5 text-center" data-testid="login-page">
      <Seo title="Sign In — Anadear Estates" description="Sign in to your Anadear Estates account." path="/login" />
      {roleLabel && <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3" data-testid="login-role-label">{roleLabel} sign in</p>}
      <h1 className="font-display text-[30px] font-300 text-[#2b2b2b] mb-2">{roleLabel ? `Welcome back, ${roleLabel.toLowerCase()}` : "Sign in to Anadear Estates"}</h1>
      <p className="text-[14px] text-[#8a8a8a] mb-6">Access your portal, saved homes and dashboard.</p>
      <button onClick={() => setOpen(true)} data-testid="login-open" className="px-8 py-3.5 rounded-full bg-[#b8935f] text-white text-[14px] font-500 hover:bg-[#a67f4d] transition-colors">Open sign in</button>
      <AuthModal open={open} onOpenChange={(o) => { setOpen(o); if (!o && !user) navigate("/"); }} defaultMode="login" />
    </div>
  );
};

export default LoginPage;
